// Generic function for copying HTML content to clipboard
export const copyHtmlToClipboard = async (html: string): Promise<boolean> => {
    try {
        const blob = new Blob([html], { type: "text/html" });
        const data = [new ClipboardItem({ "text/html": blob })];
        await navigator.clipboard.write(data);
        return true;
    } catch (err) {
        console.error("Failed to copy: ", err);
        return false;
    }
};

// Common function for content truncation
export const truncateContent = (content: string, paragraphCount: number = 2): string => {
    // Split content by paragraph tags
    const paragraphs = content.split("</p>");

    // Take only specified number of paragraphs and add closing tags back
    const truncated = paragraphs
        .slice(0, paragraphCount)
        .map((p) => p + (p.trim() ? "</p>" : ""))
        .join("");

    return truncated;
};


// Helper function to insert unlock card using TipTap commands
export const insertUnlockCardWithTipTap = (editor: any, content: string, isOptimizedMode: boolean = false) => {
    // Find all paragraph tags
    const paragraphMatches = content.match(/<p[^>]*>.*?<\/p>/gs);

    if (!paragraphMatches || paragraphMatches.length <= 4) {
        editor.commands.setContent(content);
        return;
    }

    // Get content up to the end of the 4th paragraph
    const fourth = paragraphMatches[3];
    const indexOfFourthEnd = content.indexOf(fourth) + fourth.length;
    const truncated = content.substring(0, indexOfFourthEnd);

    // Set truncated content first
    editor.commands.setContent(truncated);

    // Then insert the unlock card at the end
    editor.commands.focus('end');
    editor.commands.setUnlockCard(isOptimizedMode);
};